<!--
 * @Author: houmy
 * @Date: 2023-08-29 18:57:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 11:44:02
 * @FilePath: \zx-home\src\views\Home.vue
 * @Description: 
 * 
-->
<template>
  <div class="page">
   <Contact ref="Contact"></Contact>
    <div class="home">
      <video ref="videoPlayer" class="bannerVideo" src="https://sf-pic.oss-cn-guangzhou.aliyuncs.com/off-video/office_001.mp4" autoplay loop muted playsinline>
      </video>
      <div class="progress-bar">
        <div class="progress" :style="{ width: progressWidth }"></div>
      </div>

    </div>
    <div class="home-box product-introduction height800">
      <div class="home-title">
        <span class="title-english">{{ 'Product Introduction'.toUpperCase() }}</span>
        <div class="title-divider">
          <img src="@/assets/img/title-left.png" alt="Divider" />
          <span class="title-chinese">产品介绍</span>
          <img src="@/assets/img/title-right.png" alt="Divider" />
        </div>
        <div class="description">
          技术推动，智慧未来
        </div>
      </div>

      <div class="w12 flex-row" @mouseover="pauseCarousel" @mouseleave="resumeCarousel">
        <ul class="productList">
          <li v-for="(item, index) in productArr" :key="index*100" :class="{ 'active': isActive == index }" @mouseover="changeLi(index)">
            <p>
              {{ item.title }}
            </p>
          </li>
          <li class="viewMore" :class="{ 'active': isActive == 5 }" @click="changeLi(5)">
            <p>
              查看更多产品
              <img src="@/assets/img/arrow-right.png" alt="Divider" />
            </p>
          </li>
        </ul>
        <div class="productMain justify-between">
          <div class="productImg">
            <img v-for="(item, index) in productArr" :key="index" v-show="index === isActive" alt="Divider" :src="item.img" />
            <!-- <img :src="require(`@/assets/img/product${isActive}.png`)" alt="Divider" />
               -->
            <!-- <img :src="productInfo.img" alt="Divider" /> -->

          </div>
          <div class="productInfo">
            <h4>{{ productInfo.title }}</h4>
            <div class="blueLine"></div>
            <p>{{ productInfo.info }}</p>
           
            <button class="commonBtn viewProductDetail" @click="toProductDetail(productInfo.id, productInfo.type)">
              查看详情
            </button>
          </div>
        </div>
      </div>


    </div>
    <div class="option home-box height900">
      <img class="optionBgImg" :src="optionBgImg" alt="Divider" />
      <div class="home-title">
        <span class="title-english">{{ 'Industry Services'.toUpperCase() }}</span>
        <div class="title-divider">
          <img src="@/assets/img/title-left.png" alt="Divider" />
          <span class="title-chinese">解决方案</span>
          <img src="@/assets/img/title-right.png" alt="Divider" />
        </div>
        <div class="description">
          市场导向，客户至上
        </div>
      </div>
      <div class="optionMain">
        <el-carousel :autoplay="false" arrow="always" indicator-position="none" @change="onChange">
          <el-carousel-item v-for="(item,index) in optionArr" :key="index">
            <img class="bgImg" :src="item.img" alt="Divider" />
            <div class="optionContent">
              <h1>
                {{ item.title }}
              </h1>
              <div class="blueLine"></div>
              <p>{{ item.info }}</p>
            
              <button class="commonBtn viewOPtionDetail" @click="toSolutionDetail(item.id)">
              查看详情
            </button>
            </div>
            <ul class="optionUl flex-row">
              <li>
                <img src="@/assets/img/option_icon1.png" alt="Divider" />
                <p>提高作业效率和产量</p>
              </li>
              <li>
                <img src="@/assets/img/option_icon2.png" alt="Divider" />
                <p>精准高效惠农</p>
              </li>
              <li>
                <img src="@/assets/img/option_icon3.png" alt="Divider" />
                <p>无人化管理</p>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="demo home-box">
      <div class="home-title">
        <span class="title-english">{{ 'Selected cases'.toUpperCase() }}</span>
        <div class="title-divider">
          <img src="@/assets/img/title-left.png" alt="Divider" />
          <span class="title-chinese">精选案例</span>
          <img src="@/assets/img/title-right.png" alt="Divider" />
        </div>
        <div class="description">
          用智能科技改变生产方式
        </div>
      </div>
      <div class="demoMain">
        <!-- <el-carousel :autoplay="false" arrow="always" indicator-position="none" type="card" height="354px">
          <div class="carouselBox">
            <el-carousel-item v-for="item in demoArr" :key="item">
              <video :src="item.video" controls="controls" width="100%" height="100%" preload="auto"></video>
              <h3 class="medium">{{ item.title }}</h3>
            </el-carousel-item>
          </div>
        </el-carousel> -->
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide v-for="(item, index) in demoArr" :key="index*10">
            <video ref="currentVideo" :src="item.video" width="100%" height="100%" loop muted playsinline
              controls controlslist="nodownload"></video>
            <h3 class="medium">{{ item.title }}</h3>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="service home-box height800">
      <div class="home-title" style="margin-top: 120px;">
        <span class="title-english">{{ 'Quality service'.toUpperCase() }}</span>
        <div class="title-divider">
          <img src="@/assets/img/title-left.png" alt="Divider" />
          <span class="title-chinese">优质服务</span>
          <img src="@/assets/img/title-right.png" alt="Divider" />
        </div>
        <div class="description">
          总部扶持，全程指导
        </div>
      </div>
      <ul class="serviceMain flex-row">
        <li>
          <img src="@/assets/img/service1.png" alt="Divider" />
          <h4>专业服务</h4>
          <p>专业团队为您定制解决方案</p>
        </li>
        <li>
          <img src="@/assets/img/service2.png" alt="Divider" />
          <h4>培训支持</h4>
          <p>设备安装和行业发展全指导</p>
        </li>
        <li>
          <img src="@/assets/img/service3.png" alt="Divider" />
          <h4>辅导落地</h4>
          <p>技术人员跟进安装落地情况</p>
        </li>
        <li>
          <img src="@/assets/img/service4.png" alt="Divider" />
          <h4>技术维护</h4>
          <p>技术人员跟进产品售后维护</p>
        </li>
      </ul>
    </div>
    <div class="news home-box height800">
      <div class="home-title">
        <span class="title-english">{{ 'News & Events'.toUpperCase() }}</span>
        <div class="title-divider">
          <img src="@/assets/img/title-left.png" alt="Divider" />
          <span class="title-chinese">新闻动态</span>
          <img src="@/assets/img/title-right.png" alt="Divider" />
        </div>
        <div class="description">
          科技业成，强国梦满
        </div>
      </div>
      <ul class="newsMain">
        <li class="flex-row" v-for="(item, index) in newsArr" :key="index*1000" @click="toDetail(item, index)">
          <img class="newsImg" :src="item.img" />
          <p class="flex-col">
            <b>{{ item.title }}</b>
            <span>{{ item.info }}</span>
            <label>{{ item.time }}
              <img src="@/assets/img/rightBlueBg.png" />
            </label>
          </p>
        </li>

      </ul>
      <button class="commonBtn viewMoreNews" @click="toNews">
        查看更多
      </button>
    </div>

    <div class="contact home-box">
      <img class="contactImg" src="../assets/img/contact.png" alt="">
      <button class="commonBtn toContact" @click="onlineContact">
        <img src="../assets/img/contact2.png" alt="">产品咨询
      </button>
    </div>
    <div class="contactUs home-box height800">
      <div class="home-title" style="margin-top: 120px;">
        <span class="title-english">{{ 'Contact us'.toUpperCase() }}</span>
        <div class="title-divider">
          <img src="@/assets/img/title-left.png" alt="Divider" />
          <span class="title-chinese">联系我们</span>
          <img src="@/assets/img/title-right.png" alt="Divider" />
        </div>
        <div class="description">
          期待与您一起携手并进
        </div>
      </div>
      <ul class="w12 contactMain flex-row">
        <li>
          <img src="@/assets/img/shouye_lianxi1.png" alt="Divider" />
          <h4>联系电话</h4>
          <p>13974811172（微信同号）</p>
        </li>
        <li>
          <img src="@/assets/img/shouye_lianxi2.png" alt="Divider" />
          <h4>业务合作</h4>
          <p>business@sforceauto.com</p>
        </li>
        <li>
          <img src="@/assets/img/shouye_lianxi3.png" alt="Divider" />
          <h4>人才招聘</h4>
          <p>zhaopin@sforceauto.com</p>
        </li>
        <li>
          <img src="@/assets/img/shouye_lianxi4.png" alt="Divider" />
          <h4>公司地址</h4>
          <p>广东省佛山市顺德区陈村镇莱茵科技园3栋702</p>
        </li>
      </ul>
    </div>
  </div>
</template>
  
<script>
// import 'swiper/dist/css/swiper.css'
let vm = null
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import Contact from '../components/Contact.vue'
export default {
  components: {
    Swiper,
    SwiperSlide,
    Contact
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: 1,
        centeredSlides: true,
        slidesPerView: 3,
        spaceBetween: 20,
        // loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'custom'
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function (e) {
            vm.slideChange(this.realIndex)
          }
        }
      },
      swiperItems: [
        { image: require('@/assets/img/image.png') },
        { image: require('@/assets/img/logo.png') },
        // Add more slides here
      ],

      optionArr: [{
        id:2,
        img: require('@/assets/img/jiejuefanganNC.png'),
        bgImg: require('@/assets/img/jiejuefanganNC_BG.png'),
        title: '智慧农场综合解决方案',
        info: '六力智行智慧农场解决方案立足于农场规模化高效运营的应用需求，提供了农场管理信息平台SCPiAG、农情监测、远程调度、数字农场高精度地图基础设施等技术和产品服务，让农场经营数字化、信息化、智能化、少人化。'
      }, {
        id:1,
        img: require('@/assets/img/jiejuefanganWR.png'),
        bgImg: require('@/assets/img/jiejuefanganWR_BG.png'),
        title: '无人驾驶作业解决方案',
        info: '六力智行无人驾驶作业解决方案深度融合农机驾驶控制、农机作业控制、耕种管收农艺知识，以落地交付和推广应用为目的，注重作业效率、作业质量、拟人化操作、复杂工况处理多维度应用效果，解决用工难、用工贵的问题。六力智行无人驾驶作业解决方案涵盖了农机自动驾驶作业分级、系列化智能硬件和系统，面向农场、合作社、农服等不同客户群体提供技术和产品服务。'
      }],
      optionBgImg: '',

      isActive: 0,
      isPaused: false,
      productArr: [{
        id: 11,
        type: 1,
        img: require('@/assets/img/products/type1-1/zhutuSAVM.png'),
        title: '智能环视预警系统',
        info: '通过车载视觉设备， 系统将同一时刻的多路影像拼接成作业车辆周围的 360 °俯视图， 并显示在智能显控终端上；当障碍物靠近车身时, 会依照不同的危险程度, 发出不同频率之警示音提示驾驶员， 协助驾驶员从容操控车辆或通过复杂路面，有效降低驾驶员在作业过程中与障碍物的刮蹭碰撞与陷落山谷的概率，提高作业安全性。'
      }, {
        id: 13,
        type: 1,
        img: require('@/assets/img/products/type1-3/zhutuSCW.png'),
        title: '智能碰撞预警系统',
        info: '非道路专用多传感器融合感知预警系统，适应非道路作业工况，系统通过视觉与毫米波雷达特征融合，实现车辆的前向/后向目标物识别与距离侦测，并触发安全预警和紧急制动信息，有效降低碰撞危害。'
      }, {
        id: 21,
        type: 2,
        img: require('@/assets/img/products/type2-1/zhutuSAD200.png'),
        title: '自动驾驶作业系统SAD200',
        info: 'L2+（参考六力智行农机自驾分级），驾驶和作业控制，更省人工和创造价值。六力智行自动驾驶作业系统基于北斗，深度融合农艺，实现精准高效的驾驶和作业控制。人机结合少人化设计，大大降低驾驶劳动强度，更节省人工，解决用工难和用工贵的问题。'
      }, {
        id: 22,
        type: 2,
        img: require('@/assets/img/products/type2-2/zhutuSAD300.png'),
        title: '自动驾驶作业系统SAD300',
        info: 'L3（参考六力智行农机自驾分级），农田无人驾驶作业，解放人力。六力智行自动驾驶作业系统基于北斗，深度融合农艺，实现精准高效的驾驶和作业控制。人机结合少人化设计，大大降低驾驶劳动强度，更节省人工，解决用工难和用工贵的问题。'
      }],
      productInfo: {},

      demoArr: [
        {
          title: "搅拌车右侧盲区监测",
          video : "https://sf-pic.oss-cn-guangzhou.aliyuncs.com/off-video/0cda6c1d29a348bae1f162e1671c9830.mp4"
        },
        {
          title: '增城基地拖拉机无人驾驶',
          video: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/demo1.mp4'
        }, 
        {
          title: "插秧机辅助驾驶作业",
          video: "https://sf-pic.oss-cn-guangzhou.aliyuncs.com/off-video/1878_1749120037.mp4"
        },
        {
          title: '西安，多机安全施工',
          video: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/demo2.mp4'
        },
        {
          title: '无人驾驶收获作业',
          video: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/auto-001.mp4'
        },
        {
          title: 'SAD200自动驾驶作业系统田间插秧作业',
          video: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/demo3.mp4'
        },
      ],

      progressWidth: '0%',

      media: {
        img1: require('../assets/img/news/pic1.png'),
        img2: require('../assets/img/news/pic2.png'),
        img2_2: require('../assets/img/news/pic2-2.png'),
        img2_3: require('../assets/img/news/pic2-3.jpg'),
        img3: require('../assets/img/news/pic3.png'),
        img4: require('../assets/img/news/pic4.png'),
        video1: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/demo3.mp4',
        video2: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/video2.mp4',
        video3: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/video3.mp4',
        video4: 'https://zhix-dev.oss-cn-beijing.aliyuncs.com/off-video/video4.mp4',
        // video3: require('../assets/img/news/video3.m4v'),
      },
      newsArr: [],
      isInteracted: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {

    });
  },

  created() {
    vm = this
  },
  mounted() {
    this.$nextTick(() => {
            window.scrollTo(0, 0)
        })

    this.productInfo = this.productArr[0]
    this.startCarousel();

    this.optionBgImg = this.optionArr[0].bgImg

    const video = this.$refs.videoPlayer
    // 监听视频时间更新事件
    video.addEventListener('timeupdate', this.updateProgress)

    this.newsArr = [{
      title: '六力智造 | SAD200自动驾驶作业系统',
      info: '六力智行基于8年行业积累，整合车规技术，研发打造了SAD200自动驾驶作业系统，基于北斗，源于智能，更懂用户！SAD200自动驾驶作业系统，将自动驾驶与作业控制融合，不仅仅是简单和智能，更能创造价值，值得拥有！',
      img: require('../assets/img/news/pic1.png'),
      time: '2023-07-13 10:24',
      content: `<p>六力智行基于8年行业积累，整合车规技术，研发打造了SAD200自动驾驶作业系统，基于北斗，源于智能，更懂用户！SAD200自动驾驶作业系统，将自动驾驶与作业控制融合，不仅仅是简单和智能，更能创造价值，值得拥有！</p>
                <img src="${this.media.img1}" alt=""/>
                <p>【一键掉头】：地头一键掉头，自动转弯控制、作业装置控制、作业速度控制，轻松适应各种工况，可以升级自动掉头。 </p>
                <p>【高品质】：车规级高性能处理器和品质要求， 更快更强更安全!工况适应性强：车身姿态测量和地形补偿，适应多种工况。 </p>
                <p>【使用简单】：无接触式转角测量，简单可靠，无需标定；自动匹配历史作业轨迹，简单高效。 </p>
                <p>【信号稳定】：多种差分信号方式，三网合一，信号更稳定；支持无线电台通信。 </p>
                <p>【更省人工】：每台车节省1-2人，快速回本并创造价值。 </p>
                <p>【智能与安全】：地头自动报警，更安全，可升级环境感知与安全避障设备。SAD200自动驾驶作业系统田间插秧作业视频：</p>
                <video src="${this.media.video1}" controls></video>
                `
    }, {
      title: '六力快讯 | 热烈庆祝六力智行成立一周年!',
      info: '周年庆典2022.7.7—2023.7.7，有幸与党同月生日，时光荏苒，转眼一周年，这一年是拾回初心的一年，是生根发芽的一年，是厚积薄发的一年，从蹒跚学步到逐步壮大，感谢大家的努力，一路同行，我们会越来越好！',
      img: require('../assets/img/news/pic2.png'),
      time: '2023-07-12 16:41',
      content: `<p>周年庆典2022.7.7—2023.7.7，有幸与党同月生日，时光荏苒，转眼一周年，这一年是拾回初心的一年，是生根发芽的一年，是厚积薄发的一年，从蹒跚学步到逐步壮大，感谢大家的努力，一路同行，我们会越来越好！</p>
                <img src="${this.media.img2}" alt=""/>
                <p>2023年7月7日是公司成立一周年的日子，是所有六力人的盛大节日。公司在这天特举行一周年庆典活动，盛邀大家携同家属一同出席。活动议程： 17:30-18:00 嘉宾签到；18:00-18:05 主持人开场辞；18:10-18:15 签约仪式；18:20-18:45 领导致辞18:45-18:50 集体合影留念；18:50 晚宴开始烤全羊、烧鹅、毛血旺、牛蛙、白酒红酒、冰可乐......丰富的菜品应有尽有。桌上有肉，杯中有酒。烟火起、照人间、喜悦无边，举杯敬此年。年年有风，风吹年年。我们年复一年、年赴一年、年富一年。</p>
                <img src="${this.media.img2_2}" alt=""/>
               
                <p>进总感谢大家的到来，感谢大家对六力智行一路以来的支持与陪伴，有大家付出与信任才会有六力智行的现在。进总随后从公司发展历程，目前公司形态以及未来规划三方面展开报告：从去年7月刚成立的小团队逐渐壮大到大大小小的部门，总人数发展到32人且研发人员占比超过84%。目前，我们的产品矩阵逐渐成熟，部分产品已经具备量产条件和出口条件。在未来的岁月里，我们将会从此刻出发，依托软硬件平台化设计、系统整体集成、核心算法、场景定制开发构建属于我们六力智行的智能作业生态体系。</p>
                    <p>热烈庆祝广东六力智行科技有限公司与广州市汇奥机电有限公司就智能农机、无人驾驶作业和智慧农场等领域开展合作。双方本着互惠互利、健康发展、高效优质的合作精神，结成深度的战略合作伙伴关系！ </p>
                <img src="${this.media.img2_3}" alt=""/>
               
                <p>感谢所有同仁的选择，相信自己的选择，一起来创造波澜壮阔的明天！</p>
                <p>感谢所有家人的支持和贡献，共同撑起大家和小家，心手相连！</p>
                <p>感谢合作伙伴的帮助，我们快速成长，积极反哺，携手共进！</p>
                <p>感谢投资人的信任，投资六力，做有价值、创造价值的事业！</p>
               
                <video src="${this.media.video2}" controls></video>
                `
    }, {
      title: '六力快讯丨韦总&《车后快豹》采访',
      info: '6月30号下午，广东六力智行科技有限公司感知产品总监韦建全参加广州2023年商用车主题沙龙。智感万物，看见未来 “2023车载摄像头市场变革与扩张”主题沙龙企业如何利用好庞大的汽车领域应用需求，参与到新型技术的市场应用？智能驾驶与车联网深入耦合，要求车载摄像头质、量齐升~不仅要看得清，更要看得好！我们一同感受现场报道~',
      img: require('../assets/img/news/pic3.png'),
      time: '2023-07-12 15:00',
      content: `
            <p>6月30号下午，广东六力智行科技有限公司感知产品总监韦建全参加广州2023年商用车主题沙龙。</p>
                <p>智感万物，看见未来 “2023车载摄像头市场变革与扩张”主题沙龙</p>
                    <p>企业如何利用好庞大的汽车领域应用需求，参与到新型技术的市场应用？</p>
                        <p>智能驾驶与车联网深入耦合，要求车载摄像头质、量齐升~不仅要看得清，更要看得好！</p>
                            <p>我们一同感受现场报道~</p>
                            <video src="${this.media.video3}" controls></video>
            `
    },
    {
            title: '六力智造丨SAD300自动驾驶收获作业系统',
            info: '农业机械化程度的不断提升大大提高了我国农业生产力，但传统机械依然存在高度依赖人工、劳动强度大、操控技能要求高、作业质量难保证、夜间作业问题多等难题。',
            img: require('../assets/img/news/pic4-0.jpg'),
            time: '2023-11-15 14:47',
            content: `
                <p>农业机械化程度的不断提升大大提高了我国农业生产力，但传统机械依然存在高度依赖人工、劳动强度大、操控技能要求高、作业质量难保证、夜间作业问题多等难题。</p>
                <p>为使农户获得更加智能、轻松、高效的作业体验，实现降本增收的目标，六力智行潜心研究，精进农机导航自动驾驶解决方案，深耕农机农艺融合，让农事作业更智能、简单、省人，创造看得见、抓得住的价值。</p>
                <img src="${this.media.img4}" alt=""/>
                <p>着眼于广大农户每年作业季时间紧、任务重，耕种管收全流程均需要更高效作业的需求，六力智行SAD300自动驾驶收获作业系统真正实现了：解放双手，操作简单，易学易用；信号稳定，直线度、交接行精准，为万千用户带来省时省力，降本增收的作业体验。</p>
                <p>方案优势：</p>
                <p>【信号稳定】：三网通信，手动或自动选择最优网络，最大化保障信号畅通。</p>
                <p>【智能规划】：全局路径覆盖，最优化掉头路径，拟人化作业。</p>
                <p>【自动卸粮】：自动卸粮控制，自动选择卸粮时机和最优化卸粮局部路径设计。</p>
                <p>【智能作业】：轨迹跟踪精度高，作业行重叠少，提高作业效率。</p>
                <p>【使用简单】：人机结合，一键手/自动切换，兼顾人的灵活与自动驾驶作业的科技价值创造。</p>
                <p>SAD300自动驾驶收获作业系统田间收割作业：</p>
                <video src="${this.media.video4}" controls></video>
            `
        }
  ]
    // window.addEventListener('click', this.handleUserInteraction);
    // this.$nextTick(() => {
    //   // 获取第一个 video 元素的引用
    //   const currentVideo = this.$refs.currentVideo[0];

    //   // 播放视频
    //   currentVideo.play();
    // })




  },
  computed: {

  },
  beforeDestroy() {
    const video = this.$refs.videoPlayer
    // 移除监听事件
    video.removeEventListener('timeupdate', this.updateProgress)
  },
  methods: {
    // 产品咨询
    onlineContact(){
      this.$refs.Contact.handleShowContact()
    },
    // 新闻跳转详情
    toDetail(item, index) {
      localStorage.setItem('newsList', JSON.stringify(this.newsArr))
      localStorage.setItem('newsDetail', JSON.stringify(item))
      this.$router.push({
        path: '/newsDetail',
        query: {
          index: index,
          lastTitle: this.newsArr[index - 1] ? this.newsArr[index - 1].title : '',
          nextTitle: this.newsArr[index + 1] ? this.newsArr[index + 1].title : '',
        }
      })
    },
    // 产品介绍详情跳转
    toProductDetail(id, type) {
      this.$router.push({
        path: '/productsDetail',
        query: {
          id: id,
          type: type
        }
      })

    },
    // 解决方案详情跳转
    toSolutionDetail(id) {
      this.$router.push({
        path: '/solutionDetail',
        query: {
          id: id
        }
      })

    },

    slideChange(activeIndex) {
      const active = document.querySelector('.swiper-slide.swiper-slide-active > video')

      document.querySelectorAll('.swiper-slide > video').forEach(item => {
        item.pause()
      })

      active.play()
    },
    // banner视频进度条
    updateProgress() {
      const video = this.$refs.videoPlayer
      const currentTime = video.currentTime
      const duration = video.duration
      this.progressWidth = `${(currentTime / duration) * 100}%`
    },
    // 产品介绍切换
    changeLi(index) {
      this.isActive = index
      this.productInfo = this.productArr[index]
      if (index == 5) {
        this.$router.push({
          path: '/products'
        })
      }
    },
    // 产品介绍轮播切换
    startCarousel() {
      let this_ = this;
      this.carouselInterval = setInterval(() => {
        if (!this_.isPaused) {
          if (this_.isActive == 3) {
            this_.isActive = 0
          } else {
            this_.isActive++;
          }
          this_.productInfo = this_.productArr[this_.isActive]
        }
      }, 3000);
    },
    // 产品介绍暂停轮播
    pauseCarousel() {
      this.isPaused = true;
    },
    // 产品介绍恢复轮播
    resumeCarousel() {
      this.isPaused = false;
    },
    // 解决方案切换
    onChange(e) {
      this.optionBgImg = this.optionArr[e].bgImg
    },
    // 新闻动态查看更多
    toNews() {
      this.$router.push({
        path: '/news'
      })
    },
  }
};
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/Home.vue